define('common/ko/fn/keyBy',[
    'underscore',
    'knockout'
], function(_, ko, optimisedMapper) {

    /**
     * Same as _.keyBy but for observables.
     *
     * @param {String|Function} iteratee    See _.keyBy
     *
     * @return {PureComputed}
     */
    ko.subscribable.fn.keyBy = function(iteratee) {

        var items = this;

        return ko.pureComputed({
            read: function() {
                return _.keyBy(items(), iteratee);
            },
            write: function(newItemsByKey) {
                items(
                    items().map(function(item) {

                        var newItem;

                        if (_.isFunction(iteratee)) {
                            newItem = newItemsByKey[iteratee(item)];
                        } else {
                            newItem = newItemsByKey[item[iteratee]];
                        }

                        return newItem || item;

                    })
                );
            }
        });

    };

});

